module.exports = __webpack_public_path__ + "static/media/banner.d8e7a189.webp";